import classNames from 'classnames';
import React, {useCallback} from 'react';

import * as biojs from 'BioJS';
import * as sequtil from 'molbio/SeqUtil';
import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';
import {NoteLinkedSequencePrimer} from 'notebook/util/NoteUtilConstants';

const {modelRangeToDisplay} = sequtil;

export default function SequencePrimerPreview(props: PreviewProps): JSX.Element {
  const {item} = props;
  const renderItem = useCallback(() => {
    // @ts-expect-error(2322): we should verify that the item is a NoteLinkedSequencePrimer
    const sequencePrimer: NoteLinkedSequencePrimer = item;
    const [start, end] = modelRangeToDisplay(
      sequencePrimer.start,
      sequencePrimer.end,
      sequencePrimer.sequenceLength,
      sequencePrimer.sequenceStartIndex
    );
    const bindLength = sequencePrimer.bases.length - sequencePrimer.overhang_length;
    return (
      <div>
        <div className="note-preview-body">
          <div className="note-preview-drawing">
            <div className="location-start">{start}</div>
            <div
              className={classNames({
                'primer-render': true,
                reversed: sequencePrimer.strand === -1,
              })}
            >
              <div className="primer-body" style={{backgroundColor: sequencePrimer.color}} />
              <div className="primer-right-end" style={{borderLeftColor: sequencePrimer.color}} />
            </div>
            <div className="location-end">{end}</div>
          </div>
        </div>
        <dl className="dl-horizontal">
          <dt>Length</dt>
          <dd>{biojs.util.formatBaseCount(sequencePrimer.bases.length)}</dd>
          <dt>Binding Length</dt>
          <dd>{biojs.util.formatBaseCount(bindLength)}</dd>
          <dt>Overhang</dt>
          <dd>
            {sequencePrimer.overhang_length ? (
              sequencePrimer.bases.slice(0, sequencePrimer.overhang_length)
            ) : (
              <div className="faded">N/A</div>
            )}
          </dd>
        </dl>
      </div>
    );
  }, [item]);
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-primer',
    noteType: NoteConstants.SEQUENCE_PRIMER,
    renderItem,
  });
  return render();
}
